import React, { Component } from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

//import NoDataImg from '../../static/img/error-no-data.svg';
import NoDataImg from '@salesforce/design-system-react/assets/images/illustrations/empty-state-no-results.svg';
import './NoData.scss';

export class NoData extends Component {
  render() {
    return (
      <div className="no-data-img slds-illustration slds-illustration_small">
        <img src={NoDataImg} alt="No data" />
        <div className="slds-text-longform">
          <h3 className="slds-text-heading_medium">
            <FormattedMessage id="NoData.message" />
          </h3>
        </div>
      </div>
    );
  }
}

NoData.propTypes = {
  intl: intlShape.isRequired
};

export default injectIntl(NoData);
